import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uploadImage } from "../../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function Landing() {
  const [activeAnimation, setActiveAnimation] = useState(false);
  const data = useSelector((state) => state.main.data?.mainData?.[0]);
  const [mainPhoto, setMainPhoto] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadstart = () => {
      // Display loader when upload starts
      toast.info("Uploading image...", { autoClose: false });
    };

    reader.onload = () => {
      setMainPhoto(reader.result);
      dispatch(uploadImage(file))
        .then(() => {
          // Hide loader and show success message when upload is successful
          toast.success("Image uploaded successfully");
        })
        .catch(() => {
          // Hide loader and show error message when upload fails
          toast.error("Failed to upload image");
        });
    };

    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
      toast.error("Error reading file");
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    setActiveAnimation(true);
  }, []);
  const goToCeline = () => {
    const celineElement = document.getElementById("clinic");
    if (celineElement) {
      celineElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className={activeAnimation ? "landing-home activeAnm" : "landing-home"}
    >
      <div className="background">
        <img
          src={`https://api.atharalfarasha.com/public/hakim/${data?.main_photo}`}
          alt=""
        />
      </div>
      <div className="data">
        <div className="back-box"></div>
        <div className="data-background">
          <div className="image">
            <img
              src={
                mainPhoto
                  ? mainPhoto
                  : `https://api.atharalfarasha.com/public/hakim/${data?.main_photo}`
              }
              alt=""
            />
          </div>
          <label htmlFor="add-icon" className="add-icon">
            <lord-icon
              src="https://cdn.lordicon.com/fowixcuo.json"
              trigger="hover"
              state="hover-upload-2"
              className="img"
              style={{ width: "50px", height: "50px" }}
            ></lord-icon>
            <input
              type="file"
              id="add-icon"
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*"
            />
          </label>
        </div>
        <div className="content">
          <div className="logo">
            <img src="/images/logo.png" alt="" />
          </div>
          <div className="grouping">
            <div className="title">عيادة الدكتور</div>
            <div className="name">فادي محمود أبو فضة</div>
          </div>
        </div>
      </div>
      <div className="effects">
        <div className="effect one"></div>
        <div className="effect two"></div>
        <div className="effect three"></div>
      </div>
      <div className="about-clinic">
        <Link onClick={() => goToCeline()}>عن العيادة</Link>

        <div className="arrow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="344.283"
            height="117.681"
            viewBox="0 0 344.283 117.681"
          >
            <g
              id="Group_78"
              data-name="Group 78"
              transform="translate(-902.287 -864.105)"
            >
              <path
                id="Path_7"
                data-name="Path 7"
                d="M4017.96,2802.78s-231-15.361-325.9,102.641"
                transform="translate(-2773.518 -1936)"
                fill="none"
                stroke="#413634"
                stroke-linecap="round"
                stroke-width="4"
                class="drawing-arrow"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M3690.815,3030.675s-4.9,13.665-9.337,22.206,35.188-6.833,35.188-6.833"
                transform="translate(-2776.773 -2075.675)"
                fill="none"
                stroke="#413634"
                stroke-linecap="round"
                stroke-width="4"
                class="drawing-arrow"
              />
            </g>
          </svg>
        </div>
      </div>
    </section>
  );
}
